import Index from '../components/MaterialCategoryOrder/Index';

let routes = {
    path: '/materialCategoryOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/materialCategoryOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/materialCategoryOrder.js